import { render, staticRenderFns } from "./TableWithDrawer.vue?vue&type=template&id=3b7e372e&scoped=true"
import script from "./TableWithDrawer.vue?vue&type=script&lang=js"
export * from "./TableWithDrawer.vue?vue&type=script&lang=js"
import style0 from "./TableWithDrawer.vue?vue&type=style&index=0&id=3b7e372e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e372e",
  null
  
)

export default component.exports